export const COMPANY_TYPE = [
  {
    label: "고객사",
    value: 1,
    id: 'company'
  },
  {
    label: "세무사",
    value: 2,
    id: 'tax'
  },
  {
    label: "노무사",
    value: 3,
    id: 'labor'
  },
  {
    label: "경리대행",
    value: 9,
    id: 'master'
  },
];

export const PARTNER_COMPANY_TYPE = [
  {
    label: "세무사",
    value: 2,
  },
  {
    label: "노무사",
    value: 3,
  },
  {
    label: "경리대행",
    value: 9,
  },
];

export const PARTNER_TYPE = [
  {
    label: "파트너",
    value: 1,
  },
  {
    label: "일반",
    value: 0,
  },
];

export const COMPANY_SEP = [
  {
    label: "법인",
    value: 0,
  },
  {
    label: "개인",
    value: 1,
  },
];

export const INCOM_TYPE = [
  {
    label: "과세",
    value: 1,
  },
  {
    label: "면세",
    value: 2,
  },
  {
    label: "겸영",
    value: 3,
  },
];

export const COMPANY_STATE = [
  {
    label: "승인 거절",
    value: 0,
  },
  {
    label: "승인",
    value: 1,
  },
  {
    label: "일시 중지",
    value: 2,
  },
  {
    label: "승인 대기",
    value: 9,
  },
];

export const COMPANY_MANAGER_LEVEL = [
  { label: "주담당자", value: "1" },
  { label: "담당자", value: "2" },
  { label: "선택안함", value: "0" },
];